import { useMemo } from 'react';
import { getSummaryMetrics } from 'js/utils/question-set';
import { getCapabilityData } from 'js/utils/capabilities';

export function useCapabilityMetrics(userGroupAssessments) {
  return useMemo(() => {
    const defaults = {
      capabilities: {},
      capabilitySets: {},
      capabilityElements: {},
      metrics: {},
    };

    if (!userGroupAssessments) {
      return defaults;
    }

    const liveAssessments = userGroupAssessments
      .filter(
        (assessment) => assessment.went_live_at && !assessment.archived_at
      )
      .sort((a, b) => new Date(a.went_live_at) - new Date(b.went_live_at));

    const summaryMetrics = getSummaryMetrics(
      liveAssessments.map((a) => a.assessment)
    );

    const { capabilities, capabilitySets, capabilityElements, metrics } =
      liveAssessments.reduce((acc, userGroupAssessment) => {
        // For each live assessment, I need to get:
        // - The capability elements
        // - The capabilities involved
        // - Metrics for each question, grouped by the capability element/question key

        if (!userGroupAssessment.went_live_at) {
          return acc;
        }

        if (userGroupAssessment.capabilities) {
          userGroupAssessment.capabilities.forEach((capability) => {
            acc.capabilities[capability.id] = capability;
          });
        }

        if (userGroupAssessment.capability_sets) {
          userGroupAssessment.capability_sets.forEach((capabilitySet) => {
            acc.capabilitySets[capabilitySet.id] = capabilitySet;
          });
        }

        // extract the capabilityQuestions

        const metrics = getCapabilityData(userGroupAssessment, summaryMetrics);
        if (!metrics) {
          return acc;
        }

        acc.capabilityElements = {
          ...acc.capabilityElements,
          ...metrics.capabilityElements,
        };

        acc.metrics = {
          ...acc.metrics,
          [userGroupAssessment.id]: metrics,
        };

        return acc;
      }, defaults);

    return {
      capabilities,
      capabilitySets,
      capabilityElements,
      metrics,
    };

    // const capabilities = assessments.map((assessment) => {})
  }, [userGroupAssessments]);
}
